export default function Divider() {
  return <hr className="border-b border-solid border-gray-300 my-2" />
}
